import { NgModule } from '@angular/core';
import { LMLookupBasicComponent } from '@field/lookup';
import { TranslatePipe } from '@app/pipes';
import { FormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';
import { SohoComponentsModule } from 'ids-enterprise-ng';

@NgModule({
  declarations: [
    LMLookupBasicComponent,
    TranslatePipe
  ],
  imports: [ FormsModule, CommonModule, SohoComponentsModule ],
  exports: [
    LMLookupBasicComponent,
    TranslatePipe
  ],
})
export class LMCommonModule {}
